module.exports = __webpack_public_path__ + "media/images/top/img-top-fukkyy-430e99b43f9540ca4bc12865afbca31f.jpg";